{
  "name": "@dialectlabs/react-ui",
  "version": "2.2.0",
  "type": "module",
  "license": "Apache-2.0",
  "private": false,
  "sideEffects": false,
  "main": "dist/index.cjs",
  "module": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    },
    "./index.css": "./dist/index.css"
  },
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup-node",
    "dev": "tsup-node --watch",
    "storybook": "storybook dev -p 6006",
    "build-storybook": "storybook build"
  },
  "devDependencies": {
    "@chromatic-com/storybook": "^1.2.25",
    "@storybook/addon-essentials": "^8.0.5",
    "@storybook/addon-interactions": "^8.0.5",
    "@storybook/addon-links": "^8.0.5",
    "@storybook/addon-onboarding": "^8.0.5",
    "@storybook/blocks": "^8.0.5",
    "@storybook/react": "^8.0.5",
    "@storybook/react-vite": "^8.0.5",
    "@storybook/test": "^8.0.5",
    "@types/react": "^18.2.73",
    "@vitejs/plugin-react": "^4.2.1",
    "autoprefixer": "^10.4.19",
    "postcss": "^8.4.38",
    "postcss-prefix-selector": "^1.16.0",
    "storybook": "^8.0.5",
    "tailwindcss": "^3.4.3",
    "tsup": "^8.0.2",
    "vite": "^5.2.6"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/dialectlabs/react"
  },
  "dependencies": {
    "@dialectlabs/react-sdk": "^2.1.0",
    "clsx": "^2.1.0",
    "react-linkify-it": "^1.0.8"
  },
  "peerDependencies": {
    "@solana/wallet-adapter-react": "0.15.x",
    "react": ">=18"
  }
}
